import { DurationStepField } from '@/forms-legacy'

import { useTexts } from '../hooks/useTexts'

const wrappedInputProps = {
  step: 10,
  min: 0,
}

function secToMin(seconds: number) {
  return Math.round(seconds / 60)
}

function minToSec(minutes: number) {
  return minutes * 60
}

export function MaxDrivingTimeSec() {
  const texts = useTexts()

  return (
    <DurationStepField
      name="maxDrivingTimeSec"
      testid="maxDrivingTimeSec"
      half
      label={texts.maxDrivingTimeSec('(hh:mm)')}
      parse={minToSec}
      format={secToMin}
      wrappedInputProps={wrappedInputProps}
    />
  )
}
